<template>
  <div class="home-content-box home-message-board-box">
    <div class="home-content-body body-max-container">
    </div>
    <div v-if="swiperOptions" class="swiper">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(messageBoard, index) in messageBoardList" :key="`MessageBoard_${index}`">
          <message-board-card class="swiper-card" :message-board-data="messageBoard"></message-board-card>
          <!--
          <img :src="getCardImage(n)" alt="" class="swiper-card" />
          -->
        </swiper-slide>
        <div v-if="isDesktop" class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="enter-box body-max-container">
      <img class="enter-btn" src="../../../assets/img/icon-arrow-right.svg" alt @click="goMessageBoard" />
    </div>
  </div>
</template>

<script>
import YellowCard from "../../../assets/img/paper/paper-yellow.svg";
import BlueCard from "../../../assets/img/paper/paper-blue.svg";
import GreenCard from "../../../assets/img/paper/paper-green.svg";
import PinkCard from "../../../assets/img/paper/paper-pink.svg";
import { DeviceTypeEnum } from "@/utils/enum";
import MessageBoardCard from "@/components/MessageBoardCard";
import { MessageBoardModel } from "@/models/message-board-model";
import { fetchMessageBoard } from "@/apis/messageBoard";
import { ResponseModel } from "@/models/response-model";

export default {
  name: "HomeMessageBoard",
  components: { MessageBoardCard },
  computed: {
    isDesktop() {
      return this.$store.getters.device !== DeviceTypeEnum.MOBILE
    }
  },
  data() {
    return {
      swiperOptions: null,
      messageBoardList: []
    };
  },
  created() {
    this.initMessageBoard()
    this.setupSwiper()
    this.$nextTick(() => {
      window.addEventListener('resize', this.setupSwiper)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setupSwiper)
  },
  methods: {
    async initMessageBoard() {
      try {
        const response = await fetchMessageBoard()
        const responseData = new ResponseModel(response)
        const { messageBoardList } = responseData.result
        const loop = Math.ceil((10) / messageBoardList.length)
        const list = []
        for (let k = 0; k < loop; k++) {
          for (const i in messageBoardList) {
            list.push(new MessageBoardModel(messageBoardList[i]))
          }
        }
        this.messageBoardList = list.sort(function () {
          return Math.random() - 0.5;
        });
        console.log(` messages.length : ${ messageBoardList.length }, loop : ${loop}, final length : ${this.messageBoardList.length}`)
      } catch (e) {
        console.log(e)
      }
    },
    setupSwiper() {
      // console.log('setupSwiper')
      // this.swiperOptions = null
      const swiperOptions = {
        // rewind: true,
        slidesPerView: 6.1,
        spaceBetween: 3,
        speed: 500,
        freeMode: false,
        loop: false,
        centeredSlides: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          // bulletActiveClass: "paging-bullet-active",
          // bulletClass: "paging-bullet",
        },
      }
      // console.log(this.$store.getters.device)
      if (this.$store.getters.device === DeviceTypeEnum.TABLET) {
        swiperOptions.slidesPerView = 5.1
      } else if (this.$store.getters.device === DeviceTypeEnum.MOBILE) {
        swiperOptions.slidesPerView = 2.9
        // swiperOptions.loop = true
        // swiperOptions.centeredSlides = true
        // swiperOptions.pagination = null
      }
      this.swiperOptions = swiperOptions
      this.$nextTick(() => {
        this.$refs.mySwiper.initSwiper()
      })
    },
    getCardImage(position) {
      switch (position % 4) {
        case 0:
          return YellowCard;
        case 1:
          return BlueCard;
        case 2:
          return PinkCard;
        case 3:
          return GreenCard;
        default:
          return YellowCard;
      }
    },
    goMessageBoard() {
      this.$router.push({ name: "MessageBoard" });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-swiper-box {
  position: relative;
  background-image: url("../../../assets/img/bg-02.svg");
  background-repeat: repeat;
  background-position: center;
  background-color: #dcdcdc;
  .swiper-card {
    //width: 90%;
    height: auto;
    //-webkit-filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.7));
    //filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.7));
  }
  .swiper {
    //position: relative;
    padding-bottom: calc(100vw / 8 * 1.3);
    margin: 20px;
  }
  .swiper-container {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 25px;
    padding-bottom: 50px;
  }
  .enter-btn {
    z-index: 1;
  }
  li:before {
    background-color: transparent;
  }
}
</style>
